export enum GradeLevel {
  PreKindergarten = "GRADE_PK",
  Kindergarten = "GRADE_K",
  Grade1 = "GRADE_1",
  Grade2 = "GRADE_2",
  Grade3 = "GRADE_3",
  Grade4 = "GRADE_4",
  Grade5 = "GRADE_5",
  Grade6 = "GRADE_6",
  Grade7 = "GRADE_7",
  Grade8 = "GRADE_8",
  Grade9 = "GRADE_9",
  Grade10 = "GRADE_10",
  Grade11 = "GRADE_11",
  Grade12 = "GRADE_12",
  HighSchool = "GRADE_HS",
}

export enum DepthOfKnowledge {
  DOK1 = "DOK1",
  DOK2 = "DOK2",
  DOK3 = "DOK3",
  DOK4 = "DOK4",
}

export enum BloomsTaxonomy {
  BT1 = "BT1",
  BT2 = "BT2",
  BT3 = "BT3",
  BT4 = "BT4",
  BT5 = "BT5",
  BT6 = "BT6",
}

export enum Language {
  English = "EN",
  Spanish = "ES",
  French = "FR",
  German = "DE",
  Vietnamese = "VI",
}

export enum Subject {
  CareerTechnicalEducation = "CTE",
  EnglishLanguageArts = "ELA",
  SpanishLanguageArts = "SLA",
  Mathematics = "MATH",
  Science = "SCI",
  SocialStudies = "SS",
  MultiSubject = "MULTI",
}

export enum AssetType {
  Blueprint = "BLUEPRINT",
  Context = "CONTEXT",
  Exam = "EXAM",
  Item = "ITEM",
  Media = "MEDIA",
  Objective = "OBJECTIVE",
  /** @deprecated */
  Question = "QUESTION",
  Task = "TASK",
  User = "USER",
  /** @deprecated */
  Stimulus = "STIMULUS",
}

export enum IssueType {
  // This content contains:
  Appearance = "APPEARANCE",
  Alignment = "ALIGNMENT",
  Scoring = "SCORING", // "Incorrect or incomplete answer key(s)"
  Bias = "BIAS", // "elements of cultural bias"
  Other = "OTHER",
  Licensing = "LICENSING",
  Metadata = "METADATA",
  Preview = "PREVIEW", // is difficult to view, use or respond to
  SpellingGrammar = "SPELLING_GRAMMAR", // spelling or grammar issues
  SubjectMatter = "SUBJECT_MATTER", // factual inaccuracies
  TranslationReview = "TRANSLATION_REVIEW", // needs translation review
}

export enum PropertyType {
  AssetType = "ASSET_TYPE",
  QuestionType = "QUESTION_TYPE",
  Property = "PROPERTY",
  Objective = "OBJECTIVE",
  DepthOfKnowledge = "DOK",
  Blooms = "BLOOMS",
  Tag = "TAG",
  Keyword = "KEYWORD",
  InteractionCount = "INTERACTION_COUNT",
  ContextWordCount = "CONTEXT_WORD_COUNT",
  Lexile = "LEXILE",
  Language = "LANGUAGE",
}
